export function groupBy<T extends Record<string, any>, K extends keyof T>(
  collection: Array<T> | undefined,
  key: K
): Record<T[K], Array<T>> {
  if (!collection) {
    return {} as Record<T[K], Array<T>>
  }

  return collection.reduce(
    (acc, curr) => {
      acc[curr[key]] = acc[curr[key]] || []
      acc[curr[key]].push(curr)

      return acc
    },
    {} as Record<T[K], Array<T>>
  )
}
